import React from 'react';
import { FadeIn } from './ui/FadeIn';
const nights = [{
  day: 1,
  title: 'El ritual de cierre mental',
  desc: 'El vaciado de mente en papel: 4 pasos para sacar de tu cabeza todo lo que da vueltas y darle a tu cerebro la señal de que "esto ya está guardado." (10 minutos. Cuaderno. Bolígrafo. Listo.)'
}, {
  day: 2,
  title: 'La respiración que apaga la alarma',
  desc: 'La técnica 4-7-8: cómo usarla correctamente para bajar la activación del sistema nervioso en minutos. (No necesitas experiencia en meditación)'
}, {
  day: 3,
  title: 'Reprograma tus últimas 2 horas',
  desc: 'Los cambios específicos de luz, temperatura y contenido que preparan a tu cuerpo para soltar antes de llegar a la cama.'
}, {
  day: 4,
  title: 'El protocolo del despertar a las 3am',
  desc: 'Qué hacer exactamente si te despiertas en la madrugada: el orden paso a paso para volver a dormirte sin pelearle a tu mente.'
}, {
  day: 5,
  title: 'Los micro-hábitos diurnos',
  desc: 'Por qué lo que haces durante el día determina cómo duermes de noche — y los 3 ajustes mínimos que hacen la diferencia real.'
}, {
  day: 6,
  title: 'Gestión emocional nocturna',
  desc: 'Qué hacer con la ansiedad, la culpa y los pensamientos que aparecen en la oscuridad. Técnicas de regulación emocional simples y efectivas.'
}, {
  day: 7,
  title: 'Tu protocolo personal de por vida',
  desc: 'Cómo armar tu rutina de cierre en 3 pasos adaptada a ti, para que no necesites "volver a empezar" nunca más.'
}];
export function NightByNight() {
  return <section className="w-full bg-[#FDFBFF] py-16 md:py-24 px-6" data-id="element-223">
      <div className="max-w-4xl mx-auto" data-id="element-224">
        <FadeIn data-id="element-225">
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-12 md:mb-16" data-id="element-226">
            Lo que vas a aprender noche por noche:
          </h2>
        </FadeIn>

        <div className="space-y-4 md:space-y-6" data-id="element-227">
          {nights.map((night, index) => <FadeIn key={night.day} delay={index * 0.1} data-id="element-228">
              <div className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-purple-100 hover:border-purple-300 flex flex-col sm:flex-row gap-4 md:gap-6 items-start hover:shadow-md transition-all" data-id="element-229">
                <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 bg-purple-900 rounded-xl md:rounded-2xl flex items-center justify-center text-white font-serif text-lg md:text-xl shadow-inner" data-id="element-230">
                  🌙 {night.day}
                </div>
                <div data-id="element-231">
                  <h3 className="text-lg md:text-xl font-bold text-night-900 mb-2 md:mb-3" data-id="element-232">
                    Noche {night.day} — {night.title}
                  </h3>
                  <p className="text-sm md:text-base text-slate-600 leading-relaxed" data-id="element-233">
                    {night.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-234">
          <div className="mt-12 md:mt-16 text-center" data-id="element-235">
            <p className="text-lg md:text-2xl font-serif text-night-900 max-w-2xl mx-auto leading-relaxed px-4" data-id="element-236">
              Al terminar la semana 7 no solo vas a dormir mejor. Vas a tener
              una relación diferente con tu mente de noche.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}